import { RiskLevel } from "../../../../types/cdd-records.types";

export const getRiskBadgeClass = (risk: RiskLevel): string => {
	switch (risk) {
		case "low":
			return "bg-gradient-to-r from-emerald-100 to-green-100 text-emerald-800 border-emerald-200 shadow-sm";
		case "medium":
			return "bg-gradient-to-r from-amber-100 to-yellow-100 text-amber-800 border-amber-200 shadow-sm";
		case "high":
			return "bg-gradient-to-r from-orange-100 to-red-100 text-orange-800 border-orange-200 shadow-sm";
		case "critical":
			return "bg-gradient-to-r from-rose-100 to-red-100 text-rose-800 border-rose-200 shadow-sm";
		default:
			return "bg-gradient-to-r from-slate-100 to-gray-100 text-slate-700 border-slate-200 shadow-sm";
	}
};
